import React from "react";

const LiquidButton = ({ children }) => {
  return (
    <button className="relative px-4 py-1 text-white font-semibold rounded-full 
    backdrop-blur-lg bg-white/10 border border-white/20
    shadow-lg overflow-hidden
    transition-all duration-500
    hover:scale-105 hover:bg-white/20">

      {/* Liquid shine effect */}
      <span className="absolute inset-0 rounded-full 
      bg-gradient-to-r from-orange/30 to-transparent
      opacity-0 hover:opacity-100 
      transition-opacity duration-500 blur-xl"></span>

      {/* Glow layer */}
      <span className="absolute -inset-[2px] rounded-full 
      bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600
      opacity-30 blur-lg"></span>

      <span className="relative z-10">
        {children}
      </span>
    </button>
  );
};

export default LiquidButton;